import TopBar from './TopBar.js';
import Homepage from './Homepage.js';
import { Routes, Route } from 'react-router-dom';
import React, { Suspense, lazy, useState, useEffect  } from "react";
import firebase from './firebase.js'
import Skeleton from './Skeleton.js';
import {Helmet} from 'react-helmet';
import './App.css';

const Footer = lazy(() => import("./Footer.js"));
const BundlePage = lazy(() => import("./BundlePage.js"));
const PageNotFound = lazy(() => import("./PageNotFound.js"));
const LoginPage = lazy(() => import("./LoginPage.js"));
const ContentPage = lazy(() => import("./ContentPage.js"));
const DashPage = lazy(() => import("./DashPage.js"));

function App() {
  const [firebaseInitialized, setFirebaseInitialized] = useState(false);
  useEffect(() => {
    firebase.isInitialized().then(val => {
      setFirebaseInitialized(val)
    })
  });

  return firebaseInitialized !== false ? (
    <div className="App">
      <Suspense fallback={<Skeleton />}>
        <Routes>
          <Route exact path='/' element={
            <>
              <Helmet>
                <title>Eduard Sala Website</title>
                <meta property="og:title" content="Eduard Sala Website" />
                <meta name="description" content="I am Eduard Sala and this is my personal website. I am a digital specialist with experience across ad tech, paid media and product management." />
                <meta property="og:description" content="I am Eduard Sala and this is my personal website. I am a digital specialist with experience across ad tech, paid media and product management." />
              </Helmet>
              <TopBar />
              <Homepage />
              <Footer />
            </>
          } />

          <Route exact path='/posts' element={
            <>
              <Helmet>
                <title>Posts - Eduard Sala Website</title>
                <meta property="og:title" content="Posts - Eduard Sala Website" />
              </Helmet>

              <TopBar />
              <BundlePage />
              <Footer />
            </>
          } />

          <Route exact path='/services' element={
            <>
              <Helmet>
                <title>Services - Eduard Sala Website</title>
                <meta property="og:title" content="Posts - Eduard Sala Website" />
              </Helmet>

              <TopBar />
              <BundlePage />
              <Footer />
            </>
          } />

          <Route exact path='/projects' element={
            <>
              <Helmet>
                <title>Projects - Eduard Sala Website</title>
                <meta property="og:title" content="Posts - Eduard Sala Website" />
              </Helmet>

              <TopBar />
              <BundlePage />
              <Footer />
            </>
          } />

          <Route path='/content/:article' element={
            <>
              <TopBar />
              <ContentPage />
              <Footer />
            </>
          } />

          <Route path='/login' element={
            <>
              <TopBar minifiedBar="true" />
              <LoginPage />
              <Footer />
            </>
          } />

          {(firebase.isTheUser()) ?
            <Route path='/dash' element={
              <>
                <TopBar minifiedBar="true" />
                <DashPage />
                <Footer />
              </>
            } />
            : ""
          }

          <Route path='*' element={
            <>
              <TopBar />
              <PageNotFound />
              <Footer />
            </>
          } />

        </Routes>
      </Suspense>
    </div>
  ) : <Skeleton />
}
export default App;